import { render, staticRenderFns } from "./ModelProduct.vue?vue&type=template&id=315cf7ed&"
import script from "./ModelProduct.vue?vue&type=script&lang=js&"
export * from "./ModelProduct.vue?vue&type=script&lang=js&"
import style0 from "./ModelProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports